<template>
    <img src="https://api.survey-vip.com/qr?id=httpsasdfsadfsadfasdfsomerandomdataorother" width="100%" />
</template>

<script>

export default {
    props: ['btn']
}    
</script>